<main id="main-content" tabindex="-1" aria-label="Resources">
    <div class="container mx-auto my-10 md:px-20 px-0">
      <prism-title additionalClasses="title text-4xl" title="Resources"></prism-title>

      <p class="mb-[30px] description">
        The following resources are created by other public and private organizations. These links are provided for your
        convenience. The California Department of Education does not control or guarantee the accuracy, relevance, timeliness,
        or completeness of this outside information. Nor does it endorse any views expressed or products or services offered
        on these outside sites, or the organizations sponsoring the sites.
      </p>
      <prism-card-list
        [dataList]="resourceList"
        (cardClick)="viewResource($event)">
      </prism-card-list>
    </div>
</main>
